export default {
  "path": "/demo/dynamic-component",
  "meta": {
    "name": "demo-DynamicComponent 动态组件",
    "title": "DynamicComponent 动态组件",
    "isComponentDoc": true,
    "category": "Form"
  }
};